import { Still } from '../scenes';
import { VideoStill } from '../VideoStill';

type ProductHeroStillBaseProps = {
  kind: string;
  slug: string;
  scene: string;
  genre: string;
  sid: string;
};

type ProductHeroStillProps = ProductHeroStillBaseProps &
  (
    | { videoSrc: string; alt: string }
    | { videoSrc?: undefined; alt?: string }
  );

export function ProductHeroStill({
  kind,
  slug,
  scene,
  genre,
  sid,
  alt,
  videoSrc,
}: ProductHeroStillProps) {
  return (
    <div
      className="hero-still letterbox vignette"
      {...(alt ? { role: 'img' as const, 'aria-label': alt } : {})}
    >
      {videoSrc ? (
        <VideoStill src={videoSrc} aria-label={alt} />
      ) : (
        <Still kind={kind} sid={sid} slug={slug} scene={scene} genre={genre} />
      )}
    </div>
  );
}
